import ShopPromoLarge from "./large/shoppromo_large";
import ShopPromoSmall from "./small/shoppromo_small";
import PromoBrandShopPromo from "./brand/promo_brandshoppromo";
import BrandhubDiscoveryCard from "./brandhub/discovery_card";
import {onMount} from "@otto-ec/global-resources/dom";
import {logger} from "@otto-ec/global-resources/debug";

/**
 *
 *
 *
 *
 *
 */
export const Logger = logger("ft3.promo.shoppromo");

/*                                                          */
const info = Logger.info;
/*  */
const groupName = "[FT3 promo shoppromo]";

onMount(".promo_shoppromo-large--container", (element) => {
    info.group(groupName);
    info.count("Large Shoppromo Invocation");
    new ShopPromoLarge(element);
    info.groupEnd();
});

onMount(".promo_shoppromo_small--container", (element) => {
    info.group(groupName);
    info.count("Small Shoppromo Invocation");
    new ShopPromoSmall(element as HTMLElement);
    info.groupEnd();
});

onMount(".promo_brandshoppromo--container", (element) => {
    info.group(groupName);
    info.count("Brandshoppromo Invocation");
    new PromoBrandShopPromo(element);
    info.groupEnd();
});

onMount(".promo_brandhub_discovery_card__container", (element) => {
    info.group(groupName);
    info.count("Brandhub Discovery Card Invocation");
    new BrandhubDiscoveryCard(element);
    info.groupEnd();
});
